import * as React from 'react';
import { Helmet } from 'react-helmet';
import { withTweekKeys } from 'react-tweek';
import { compose, withProps } from 'recompose';
import { NotFound, partnerTheme } from '@soluto-home-web/platform-common-ui';
import { default as ContentViewer, ContentViewerItem } from './ContentViewer';

type OuterProps = {
  contentItems?: ContentViewerItem[];
  id: string;
};

type InnerProps = { item?: ContentViewerItem };

const ContentViewerById = ({ item }: InnerProps) =>
  item ? (
    <>
      {item.header ? (
        <Helmet>
          <title>{`${item.header} - ${partnerTheme.texts.partner_service_name}`}</title>
        </Helmet>
      ) : null}
      <ContentViewer item={item} />
    </>
  ) : (
    <NotFound />
  );

const createFallbackContent = (id: string) => {
  console.log(id);
  const item: ContentViewerItem = {
    header: null,
    id: id,
    url: `https://kb.mysoluto.com/index.php?p=${id}`,
  };

  return item;
};

export { OuterProps as ContentViewerProps };

export default compose<InnerProps, OuterProps>(
  withTweekKeys({ contentItems: 'soluto_home_web/homepage/publication/items' }),
  withProps<InnerProps, OuterProps>(({ contentItems, id }) => {
    const item = contentItems && contentItems.find((x) => x.id === id);
    return { item: item || createFallbackContent(id) };
  })
)(ContentViewerById);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/content-viewer/components/ContentViewerById.tsx